import React, { Component } from "react";
import Headers from "../Layouts/Headers";
import TheatreSidebar from "../Layouts/TheatreSidebar";

import axios from "axios";
import $ from "jquery";

export class IntraOperativeElectrosurgicalUnitAnaesthesia extends Component {
  constructor(props) {
    super(props);

   

    const url = "";

    this.state = {
      ESUnitNo: "",
      ESMode: "",
      CoagSet: "",
      CutSet: "",
      SkinCheckBefore: "",
      SkinCheckAfter: "",
      location: "",
      BPcuff: "",
      Spo2Probe: "",
      IVCannulae: "",
      CVPline: "",
      ArterialLine: "",
      ThroatPacked: "",
      EyesTaped: "",
      TypeofAnaesthesia: "",

      // 				visitid = request.headers["visitid"],
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.PrintWindow = this.PrintWindow.bind(this);
  }

  PrintWindow(event) {
    document.title =
      localStorage.getItem("currentVisitName") + "`s " + this.constructor.name;
    $(".modal").hide();
    window.print();
  }
  componentDidMount() {
    $(".deadonehouryes").click(function () {
      $(".deadonereason").show();
    });
    $(".deadonehourno").click(function () {
      $(".deadonereason").hide();
    });

    $(".stillbirthyes").click(function () {
      $(".stillbirthtype").show();
    });
    $(".stillbirthno").click(function () {
      $(".stillbirthtype").hide();
    });
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("currentVisitId"),
      surgeryid: localStorage.getItem("surgeryid"),
    };
    event.preventDefault();
    console.log(this.state);
    axios
      .post(
        this.api_url+"optheatre/operativeorders/intra/optheatre/electrosurgicalunitanaesthesia",
        this.state,
        { headers: headers }
      )
      .then((response) => {
        console.log(response);

        if (response.data["status"]) {
          $(".alert-success").show();
        }

        setTimeout(function () {
          window.location.href = "/theatre/intra/op/theatre/entry";
        }, 500);

        //
      })
      .catch((error) => {
        console.log(error);
        $('#SubmitError').show();
        $(".alert-success").hide();
      });
  };
  render() {
    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };
    const {
      ESUnitNo,
      ESMode,
      CoagSet,
      CutSet,
      SkinCheckBefore,
      SkinCheckAfter,
      location,
      BPcuff,
      Spo2Probe,
      IVCannulae,
      CVPline,
      ArterialLine,
      ThroatPacked,
      EyesTaped,
      TypeofAnaesthesia,
    } = this.state;
    return (
      <div>
        <Headers />
        <TheatreSidebar />

        <main>
          <div className="container p-2">
            <form onSubmit={this.handleSubmit}>
              <div className="form-row pt-4">
                <div className="col-md-4 p-2"></div>
              </div>
              <div className="form-row pt-4">
                <div className="col-md-4 text-lg-center font-weight-bold p-1">
                  <p className="text-capitalize" style={font16}>
                    IntraOperative Entry
                  </p>
                </div>

                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      ESUnitNo
                    </h6>
                    <input
                      type="text"
                      className="form-control"
                      onChange={this.handleChange}
                      value={ESUnitNo}
                      name="ESUnitNo"
                      required
                    />
                  </div>

                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      ESMode
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={ESMode}
                      name="ESMode"
                      type="text"
                      required
                    />
                  </div>
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      CoagSet
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={CoagSet}
                      name="CoagSet"
                      type="text"
                      required
                    />
                  </div>
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      TypeofAnaesthesia
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={TypeofAnaesthesia}
                      name="TypeofAnaesthesia"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      CutSet
                    </h6>
                    <input
                      type="text"
                      className="form-control"
                      onChange={this.handleChange}
                      value={CutSet}
                      name="CutSet"
                      required
                    />
                  </div>

                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      SkinCheckBefore
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={SkinCheckBefore}
                      name="SkinCheckBefore"
                      type="text"
                      required
                    />
                  </div>
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      SkinCheckAfter
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={SkinCheckAfter}
                      name="SkinCheckAfter"
                      type="text"
                      required
                    />
                  </div>
                </div>
              </div>

              <div className="form-row pt-4">
                <div className="col-md-4 text-lg-center font-weight-bold p-1">
                  <p className="text-capitalize" style={font16}></p>
                </div>

                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      location
                    </h6>
                    <input
                      type="text"
                      className="form-control"
                      onChange={this.handleChange}
                      value={location}
                      name="location"
                      required
                    />
                  </div>

                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      BPcuff
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={BPcuff}
                      name="BPcuff"
                      type="text"
                      required
                    />
                  </div>
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Spo2Probe
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={Spo2Probe}
                      name="Spo2Probe"
                      type="text"
                      required
                    />
                  </div>
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      ThroatPacked
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={ThroatPacked}
                      name="ThroatPacked"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      IVCannulae
                    </h6>
                    <input
                      type="text"
                      className="form-control"
                      onChange={this.handleChange}
                      value={IVCannulae}
                      name="IVCannulae"
                      required
                    />
                  </div>

                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      CVPline
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={CVPline}
                      name="CVPline"
                      type="text"
                      required
                    />
                  </div>
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      ArterialLine
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={ArterialLine}
                      name="ArterialLine"
                      type="text"
                      required
                    />
                  </div>
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      EyesTaped
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={EyesTaped}
                      name="EyesTaped"
                      type="text"
                      required
                    />
                  </div>
                </div>
              </div>

              <div
                id="loginSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Details Saved Successfully.
              </div>

              <div className="row">
                <br />
                <br />
                <br />
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default IntraOperativeElectrosurgicalUnitAnaesthesia;
